import { memo, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CircularProgress, Grid2, Typography } from "@mui/material";

import Spinner from "../components/Spinner.js";
import Search from "../components/Search.js";
import LeaderboardComponent from "../components/Leaderboard.js";
import { useSnackbar } from "../utils/index.js";
import { getScores } from "../api/index.js";

const Leaderboard = () => {
	const { TASK_ID } = useParams();
	const { error } = useSnackbar();
	const [isLoading, setIsLoading] = useState(false);
	const [isLeaderboardLoading, setIsLeaderboardLoading] = useState(true);
	const [searchFilter, setSearchFilter] = useState("");
	const [scores, setScores] = useState([]);
	const [task, setTask] = useState("All Scores");

	const fetchScores = async () => {
		setIsLoading(true);
		const { success: fetchSuccess, scores: fetchedScores, task: fetchedTask, message } = await getScores(TASK_ID);
		if (fetchSuccess) {
			setScores(fetchedScores);
			setTask(fetchedTask);
		} else {
			error(message);
		}

		setIsLoading(false);
		setIsLeaderboardLoading(false);
	};

	useEffect(() => {
		fetchScores();
	}, [TASK_ID]);
	
	return (
		<>
			<Spinner open={isLoading} />
			<Grid2 container display="flex" direction="column" justifyContent="center" alignItems="center">
				<Grid2 width="80%" display="flex" alignItems="center" justifyContent="space-between">
					<Typography fontSize={22} fontWeight="bold">{task}</Typography>
					<Search width="500px" value={searchFilter} onChange={(event) => setSearchFilter(event.target.value)} />
				</Grid2>
				<Grid2 mt={3} width="80%">
					{isLeaderboardLoading
						? (
							<Grid2 container justifyContent="center">
								<CircularProgress color="third" size={60} />
							</Grid2>
						)
						: <LeaderboardComponent leaderboard={scores} search={searchFilter} />
					}
				</Grid2>
			</Grid2>
		</>
	);
};

export default memo(Leaderboard);
